import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
const addDiv = document.querySelector('#root');

ReactDOM.render(
  <App />,
  addDiv
)



// WEBPACK FOOTER //
// ./src/index.js